var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookedStudents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_user-octagon",
    "data-name": "vuesax/bold/user-octagon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.212,
    height: 54.212,
    viewBox: "0 0 54.212 54.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_user-octagon-2",
    "data-name": "vuesax/bold/user-octagon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-octagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H54.212V54.212H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M40.216,9.093l-14.4-8.1a7.843,7.843,0,0,0-7.636,0L3.806,9.093A7.405,7.405,0,0,0,0,15.541V31.7a7.462,7.462,0,0,0,3.806,6.448l14.4,8.1a7.843,7.843,0,0,0,7.636,0l14.4-8.1A7.405,7.405,0,0,0,44.046,31.7V15.541A7.507,7.507,0,0,0,40.216,9.093ZM22.011,12.612a5.505,5.505,0,1,1-5.648,5.5A5.567,5.567,0,0,1,22.011,12.612Zm6.5,22.013H15.514A2.37,2.37,0,0,1,13.5,30.917a10.3,10.3,0,0,1,8.509-3.992,10.3,10.3,0,0,1,8.509,3.992A2.38,2.38,0,0,1,28.508,34.625Z",
    transform: "translate(5.091 3.487)",
    fill: "#2a4c7d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookedStudents);
export default __webpack_public_path__ + "static/media/BookedStudents.08c6f5112df16216a06adfbc78f74d4e.svg";
export { ForwardRef as ReactComponent };